import React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Home from "routes/Home";
import "./styles/globals.css";
import { Provider } from "react-redux";
import store from "./store";
import { Layout } from "routes/Layout";

const router = createHashRouter([
  {
    path: "/",
    element: <Layout />,
  },
  {
    path: "/user-info",
    element: <Home />,
  },
]);

const RootApp = () => {
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};

const AppWithAuth = () => (
    <RootApp />
);

export default AppWithAuth;
